import { createAction } from 'redux-actions';
import {
    SET_FORMVALUE
} from '../constants/actionTypes';
import { doGet, doPost } from '../utils/AjaxRequests'
import _ from 'lodash'
import { apiPrefixUrl } from '../utils/connection'
import Swal from 'sweetalert2'
import { setResultValue } from './resultAction'
import { history } from '../router/history'
import { formDefault } from '../constants/model'
import { setOption } from './optionAction'

export const setFormValue = createAction(SET_FORMVALUE)

export const resetForm = () => {
    return (dispatch, getState) => {
        _.map(formDefault, (item, key) => {
            dispatch(setFormValue({
                field: key,
                value: item
            }))
        })

        dispatch(setOption({ field: "conform", options: [] }))
        dispatch(setOption({ field: "schdTime", options: [] }))
        dispatch(setOption({ field: "AREA_CODE", options: [] }))
    }
}

export const submit = (schd_type) => {
    return (dispatch, getState) => {

        const form = (getState().getIn(["form"])).toJS()
        const timeOptions = (getState().getIn(["option", "schdTime"])).toJS()

        if (!form.PAT_NAME) {
            Swal.fire("請輸入姓名", "", "error")
            return
        }

        if (!form.PAT_IDNO) {
            Swal.fire("請輸入身分證字號", "", "error")
            return
        }

        // if (!form.AREA_CODE) {
        //     Swal.fire("請選擇通訊地址鄉鎮市區", "", "error")
        //     return
        // }

        // if (!form.ADDRESS) {
        //     Swal.fire("請填寫通訊地址", "", "error")
        //     return
        // }


        // if(form.NO_ROC_ID==="Y" && (!form.PASSPORT_NUMBER && !form.RC_NUMBER)){
        //     Swal.fire("請輸入居留證號碼或護照證字號", "", "error")
        //     return
        // }             

        if (!form.SEX) {
            Swal.fire("請輸入性別", "", "error")
            return
        }

        if (!form.BIRTHDAY) {
            Swal.fire("請輸入生日", "", "error")
            return
        }

        if (!form.TEL_MOBILE) {
            Swal.fire("請輸入手機號碼", "", "error")
            return
        }



        const timeSlot = _.find(timeOptions, (o) => { return o.SCHD_ID === form.schdTimeId })

   

        if (!timeSlot) {
            Swal.fire("token錯誤", "", "error")
            return
        }

        dispatch(setFormValue({ field: "loading", value: true }))

        const payload = {
            "api": "APCBookingV2",            
            "SCHD_TYPE":schd_type,
            "CONSULT_OPTIONS":form.consult, 
            "SCHD_ID_STR": form.schdTimeId,
            "USER_ID": "patient",
            "PAT_IDNO": form.PAT_IDNO,
            "PAT_NAME": form.PAT_NAME,
            "TEL_MOBILE": form.TEL_MOBILE,
            "EMAIL": form.EMAIL,
            "TOKEN": timeSlot.TOKEN,
            "KEY":timeSlot.KEY,
            "NOON":timeSlot.NOON,   
            "START_DATE":timeSlot.START_DATE,
            "SPNO":"",
            // "TICKET_NO": form.TICKET_NO,           
            "BIRTHDAY": form.BIRTHDAY,
            "SEX": form.SEX,            
            // "CONFORM_TYPE": form.conformId,          
            // "NATIONALITY": form.NATIONALITY,
            // "PASSPORT_NUMBER": form.PASSPORT_NUMBER,
            // "RC_NUMBER": form.RC_NUMBER,
            // "AREA_CODE": form.AREA_CODE,
            // "ADDRESS": form.ADDRESS,
            // "ROLE_PAT_IDNO": form.ROLE_PAT_IDNO,
            // "ROLE_PAT_NAME": form.ROLE_PAT_NAME,
            // "CONFORM_TYPE_OTHERS": form.CONFORM_TYPE_OTHERS,
            // "OUTBOUND_DATE": form.OUTBOUND_DATE,
            // "FLIGHT_NO": form.FLIGHT_NO,
            // "NO_ROC_ID": form.NO_ROC_ID,
            // "PASSPORT_NAME": form.PASSPORT_NAME,
            // "EMP_NO": form.EMP_NO,
            // "SPNO": "",

        }

        // console.log(payload);

        doPost(apiPrefixUrl, payload)
            .then((data) => {
                if (data.status && data.data) {
                    dispatch(setResultValue({ value: data.data }))
                    dispatch(resetForm())
                    dispatch(setFormValue({ field: "loading", value: false }))
                    history.push('/result')
                } else {
                    throw Error(data.message)
                }
            })
            .catch((e) => {
                Swal.fire(e.message, "", "error")
                dispatch(setFormValue({ field: "loading", value: false }))
            })
    }
}


